import { Benefit } from "@/api/products";
import ChoiceBenefits from "../ChoiceBenefits";
import { WhatsApp } from "../Extras/WhatsApp";
import { RedesSociais } from "../Extras/RedesSociais";
import { MinuteBenefits } from "../MinuteBenefits";
import { InternetAcumulada } from "../Extras/InternetAcumulada";

export type BenefitsProps = {
  benefits: Benefit[];
};

const Benefits: React.FC<BenefitsProps> = ({ benefits }) => {
  const benefitTypeChoices = benefits
    .filter((benefit) => benefit.tipo === "escolhas")
    ?.sort((a, b) => a.descricao.localeCompare(b.descricao));
  const benefitTypeBenefit = benefits
    .filter((benefit) => benefit.tipo === "beneficios")
    ?.sort((a, b) => a.descricao.localeCompare(b.descricao));

  const redesSociais = benefits.find(
    ({ componente }) => componente === "RedesSociais"
  );

  const hasInternetAcumulada = benefits.find(
    ({ componente }) => componente === "InternetAcumulada"
  );

  const hasDescontoExtra = benefits.find(
    ({ componente }) => componente === "DescontoExtra"
  );

  const mensagemEscolhas = hasDescontoExtra ?
    'Acesse o App Meu TIM e escolha entre um streaming ou Desconto Extra de R$ 5,00!' :
    'Acesse o Meu TIM para escolher ou trocar seus benefícios (sem custo adicional ao plano)!';

  const whatsApp = benefits.find(({ componente }) => componente === "WhatsApp");

  return (
    <>
      <InternetAcumulada hasInternetAcumulada={!!hasInternetAcumulada} />

      <WhatsApp label={whatsApp?.descricao} />

      <RedesSociais
        hide={!redesSociais}
        label={`${redesSociais?.quantidade} ${redesSociais?.descricao}`}
      />

      {benefitTypeChoices.length > 0 && (
        <>
          <p className="pt-2 text-gray-700">
            <small>
              {mensagemEscolhas}
            </small>
          </p>
          {benefitTypeChoices.map((benefit, index) => (
            <ChoiceBenefits
              key={benefit.descricao + String(index)}
              label={benefit.descricao}
              component={benefit.componente}
              hasAds={benefit.hasAds}
            />
          ))}
        </>
      )}

      {benefitTypeBenefit.length > 0 && (
        <>
          <p className="pt-2 text-gray-700">
            <small>
              <strong>Mais aplicativos:</strong>
            </small>
          </p>
          {benefitTypeBenefit.map((benefit, index) => (
            <ChoiceBenefits
              key={benefit.descricao + String(index)}
              label={benefit.descricao}
              component={benefit.componente}
              hasAds={benefit.hasAds}
            />
          ))}
        </>
      )}

      <MinuteBenefits benefits={benefits} />
    </>
  );
};

export default Benefits;
